import { defineStore } from 'pinia'
import { computed } from 'vue'
import i18n, { type AppLocale, setDocumentLocale } from '@/i18n'
import { updateUserPreference } from '@/api/users'
import dayjs from 'dayjs'
import 'dayjs/locale/zh-cn'
import 'dayjs/locale/en'

export const useLocaleStore = defineStore('locale', () => {
  const locale = computed<AppLocale>(() => i18n.global.locale.value as AppLocale)

  async function changeLanguage(lang: AppLocale): Promise<void> {
    i18n.global.locale.value = lang
    setDocumentLocale(lang)
    dayjs.locale(lang === 'en' ? 'en' : 'zh-cn')
    // 登录页等未登录场景没有 token，偏好同步接口必然 403（统一错误处理会弹无权限提示），
    // 此时跳过同步即可，语言切换本身已生效
    if (!localStorage.getItem('token')) {
      return
    }
    try {
      await updateUserPreference({ preferredLanguage: lang })
    } catch {
      // 网络异常时忽略，语言切换本身已生效
    }
  }

  return { locale, changeLanguage }
})
